import React from "react";
import "../assets/styles/components/APropos.css";

const APropos = () => {
  return (
    <section id="a-propos" className="py-5">
      <div className="container text-center">
        <h2 className="section-title">Qui sommes-nous ?</h2>
        <div className="row">
          <div className="col-md-6">
          <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d2285.9105524698466!2d2.3920954684078857!3d48.99873370127272!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m5!1s0x47e66a16f70b91c5%3A0x23b9997017ccd222!2s11%20Av.%20des%20Entrepreneurs%2C%2095400%20Villiers-le-Bel!3m2!1d48.9990543!2d2.3938349!4m0!5e1!3m2!1sfr!2sfr!4v1736357187442!5m2!1sfr!2sfr" 
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="ACG VO"
        ></iframe>
          </div>
          <div className="col-md-6">
            <h3 className="about-title">Notre entreprise</h3>
            <p className="about-description">
              ACG VO, est votre partenaire de
              choix pour la location d'espaces professionnels à Villiers-Le-Bel
              dans le Val d'Oise. Nous offrons des solutions flexibles et
              adaptées à vos besoins, que vous recherchiez un bureau privé, une
              salle de réunion équipée, ou un espace de coworking convivial.
              Notre mission est de créer un environnement propice à la
              productivité et à l'innovation, tout en favorisant les échanges et
              la collaboration. Grâce à notre emplacement stratégique et à nos
              services personnalisés, nous nous engageons à accompagner les
              entreprises de toutes tailles dans leur développement. Rejoignez-nous
              pour un espace de travail qui inspire et stimule vos ambitions
              professionnelles.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default APropos;
